import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var RETRY_HTTP_CODES = [408, 500, 502, 503, 504, 522, 524];
function timeout(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
function fetchRetry(_x) {
  return _fetchRetry.apply(this, arguments);
}
function _fetchRetry() {
  _fetchRetry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
    var options,
      retries,
      backoff,
      response,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          retries = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 5;
          backoff = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 300;
          _context2.next = 5;
          return fetch(url, options);
        case 5:
          response = _context2.sent;
          if (!(response.ok || response.status === 401)) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", response);
        case 8:
          if (!(retries > 0 && RETRY_HTTP_CODES.includes(response.status))) {
            _context2.next = 16;
            break;
          }
          _context2.next = 11;
          return timeout(backoff);
        case 11:
          _context2.next = 13;
          return fetchRetry(url, options, retries - 1, backoff * 2);
        case 13:
          return _context2.abrupt("return", _context2.sent);
        case 16:
          return _context2.abrupt("return", Promise.reject(response));
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchRetry.apply(this, arguments);
}
export var postHeartbeat = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(endpoint, onAuthenticationFailed, onBadRequest) {
    var response, errorResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetchRetry(endpoint, {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 3:
          response = _context.sent;
          if (!(response && response.ok)) {
            _context.next = 6;
            break;
          }
          return _context.abrupt("return", response.json());
        case 6:
          if (!(response && response.status === 401 && onAuthenticationFailed)) {
            _context.next = 9;
            break;
          }
          onAuthenticationFailed();
          return _context.abrupt("return");
        case 9:
          _context.next = 18;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          errorResponse = _context.t0;
          if (!(errorResponse.status === 400)) {
            _context.next = 17;
            break;
          }
          onBadRequest === null || onBadRequest === void 0 || onBadRequest();
          return _context.abrupt("return", Promise.reject(errorResponse));
        case 17:
          if (RETRY_HTTP_CODES.includes(errorResponse.status)) {
            console.warn('Heartbeat: Retried 5x, stopped to call api');
          }
        case 18:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  }));
  return function postHeartbeat(_x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();